//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[[0,"ConvertToOriginalModelView",1,0],[0,"LinearDimensionTolerance",1,0],[0,"PreserveDraftingLayer",1,0],[0,"PreserveHiddenStatus",1,0],[0,"ProcessObjectsHidden",1,0],[0,"Units",1,0]],[[["annType","annValue"],"SaveAnnotationType",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.AnnotationSettingsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.AnnotationSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.AnnotationSettingsBuilder.UnitsEnum = Object.freeze({
    "UseTargetPartUnits" : "UseTargetPartUnits", "UseDrawingUnits" : "UseDrawingUnits"});

SPLM.Drawings.AnnotationSettingsBuilder.AnnotationTypeEnum = Object.freeze({
    "Dimension" : "Dimension", "Note" : "Note", "FeatureControlFrame" : "FeatureControlFrame", "DatumFeatureSymbol" : "DatumFeatureSymbol", "DatumTarget" : "DatumTarget", "Balloon" : "Balloon", "SurfaceFinishSymbol" : "SurfaceFinishSymbol", "WeldSymbol" : "WeldSymbol", "CustomSymbol" : "CustomSymbol", "CenterLine" : "CenterLine", "UserDefinedSymbol" : "UserDefinedSymbol", "EdgeConditionSymbol" : "EdgeConditionSymbol", "MaxAnnotationYypes" : "MaxAnnotationYypes"});

export default SPLM;